$(document).ready(function(){
  $('.review_row').slick({
    dots: true,
    slidesToShow:3,
    slidesToScroll: 1,
    adaptiveHeight: false,
    variableWidth: false,
    centerMode: false,
    arrows:true,
    responsive: [
      
      {
        breakpoint: 1023,
        settings: {
        slidesToShow:2,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true,
        }
      },
      
      {
        breakpoint:767,
        settings:"unslick",
      
      },
    ] 
  });
});